import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from '@mui/material/Unstable_Grid2';
import Masonry from "@mui/lab/Masonry";

export const SimpleDetail = ({ children, header, columns = 2 }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container>
        <Grid xs={12} sx={{ pl: "4px"}}>
          <Typography
            variant="h5"
            noWrap
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontWeight: 700,
              letterSpacing: ".3rem",
              textDecoration: "none",
            }}
            color="primary"
          >
            {header}
          </Typography>
        </Grid>
        <Grid xs={12} sx={{ paddingTop: "2vh" }}>
          <Masonry columns={columns} spacing={2}>
            {children}
          </Masonry>
        </Grid>
      </Grid>
    </Box>
  );
};
